/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_AnalysisInputs */

const en_page_title_analysis = /** @type {(inputs: Page_Title_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis`)
};

const nl_page_title_analysis = /** @type {(inputs: Page_Title_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse`)
};

/**
* | output |
* | --- |
* | "Analysis" |
*
* @param {Page_Title_AnalysisInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_analysis = /** @type {((inputs?: Page_Title_AnalysisInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_AnalysisInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_analysis(inputs)
	return en_page_title_analysis(inputs)
});